import { useTailwindBreakpoints } from "components/hooks/use-tailwind-breakpoints"
import { Box } from "components/shared/box"
import { useMemo } from "react"
import styles from "./ability-grade.module.scss"

export const fiveItemsArr = new Array(5).fill(null)

export type AbilityGradeProps = {
  level: number
  maxLevel?: number
}

export function AbilityGrade({ level, maxLevel = 3 }: AbilityGradeProps) {
  const { isMobile } = useTailwindBreakpoints()
  const maxLevelArr = useMemo(() => new Array(maxLevel).fill(null), [maxLevel])
  return (
    <Box row className="gap-2 p-1 mt-2 lg:mt-0 w-[5rem] lg:w-full justify-between">
      {maxLevelArr.map((item, i) => (
        <span
          key={i}
          className={`w-full h-[4px] rounded-2xl lg:h-[8px] ${
            level > i
              ? styles[isMobile ? "ability-level-gradient-mobile" : "ability-level-gradient"]
              : isMobile
              ? "bg-[#000000] opacity-50"
              : "bg-[#4F4ACC]"
          }`}
        />
      ))}
    </Box>
  )
}
